import PropTypes from 'prop-types';

import { useCustomColumnVariables } from '#customColumnsFeature/hooks/useTemplateVariables';
import GreetingConfigurator from '#globalComponents/VariableInserter/GreetingConfigurator';
import MissingFallbackHint from '#globalComponents/VariableInserter/MissingFallbackHint';
import VariableInserter from '#globalComponents/VariableInserter/VariableInserter';

// name = the merge-field key, label = what the user sees. Person fields offer a fallback
// (empty for company recipients without a contact); company never needs one.
const RECIPIENT_VARIABLES = [
	{ name: 'firstName', label: 'Vorname', fallbackPlaceholder: 'z.B. zusammen' },
	{ name: 'lastName', label: 'Nachname' },
	{ name: 'fullName', label: 'Vollst. Name' },
	{ name: 'email', label: 'E-Mail' },
	{ name: 'company', label: 'Unternehmen' },
];

const TARGET_LABELS = { subject: 'Betreff', body: 'E-Mail-Text' };

const GroupLabel = ({ children }) => <p className="text-xs-head text-bgBase-800 mb-1.5">{children}</p>;

GroupLabel.propTypes = { children: PropTypes.node };

/**
 * Placeholder pills of the e-mail template editor, grouped into recipient fields and the org's
 * custom columns. A pill is inserted where the cursor was last — subject or body.
 */
const TemplateVariablesPanel = ({ target, onInsert, text }) => {
	const customVariables = useCustomColumnVariables();

	return (
		<div className="space-y-4">
			<div>
				<h4 className="text-sm font-semibold text-text">Platzhalter</h4>
				<p className="text-[11px] text-bgBase-800 mt-0.5">
					Wird an der Cursor-Position eingefügt in:{' '}
					<strong className="text-text">{TARGET_LABELS[target]}</strong>
				</p>
			</div>

			<div>
				<GroupLabel>Kontakt & Firma</GroupLabel>
				<VariableInserter
					variables={RECIPIENT_VARIABLES}
					braces="single"
					align="right"
					onInsert={onInsert}
					trailing={<GreetingConfigurator onInsert={onInsert} align="right" />}
				/>
			</div>

			<div>
				<GroupLabel>Eigene Spalten</GroupLabel>
				{customVariables.length > 0 ? (
					<VariableInserter variables={customVariables} braces="single" align="right" onInsert={onInsert} />
				) : (
					<p className="text-[11px] text-bgBase-800">
						Noch keine eigenen Spalten. Sie lassen sich in jeder Kontaktliste über „Spalten“ anlegen.
					</p>
				)}
			</div>

			<MissingFallbackHint text={text} braces="single" />
		</div>
	);
};

TemplateVariablesPanel.propTypes = {
	target: PropTypes.oneOf(['subject', 'body']).isRequired,
	onInsert: PropTypes.func.isRequired,
	// Subject + body as plain text, for the missing-fallback hint.
	text: PropTypes.string.isRequired,
};

export default TemplateVariablesPanel;
